import type { BlsDotColor, BlsDotSize } from "../../domain/blsChannel";

/**
 * How the stimulus looks.
 *
 * Fixed colours rather than room tokens: this is a clinical stimulus on its
 * own dark field, chosen for contrast and comfort to follow, not part of the
 * chrome — it must look the same whatever the theme does. Every dot is bright
 * against the field and none is saturated red, which is the colour most
 * associated with photosensitive reactions.
 */
export const BLS_FIELD_COLOR = "#0b0b12";

export const BLS_DOT_HEX: Record<BlsDotColor, string> = {
    white: "#f5f5f5",
    green: "#4ade80",
    blue: "#60a5fa",
    yellow: "#facc15",
};

/** Diameter as a share of the field's width, so the preview scales with it. */
export const BLS_DOT_SCALE: Record<BlsDotSize, number> = {
    small: 0.025,
    medium: 0.04,
    large: 0.06,
};

/** Never smaller than this, or the preview's dot disappears. */
export const BLS_MIN_DOT_PX = 8;
